import Image from "next/image";
import { cn } from "@/lib/utils";

/**
 * Logo ufficiale del ristorante (file fornito dal cliente il 06/10/2026, PNG
 * ritagliato e con sfondo trasparente in public/brand/logo.png: bottiglia con
 * le ali + "IL POZZO" con le ZZ rosse + "RISTORANTE ENOTECA"). Contiene già
 * il testo, per questo l'immagine ha un `alt` vero e non c'è più il nome
 * scritto a parte accanto al simbolo.
 *
 * L'altezza si decide da fuori (`className`, es. "h-24"): la larghezza segue
 * le proporzioni. `priority` solo per l'istanza sopra la piega (Nav) — nel
 * Footer creava un preload mai "consumato" (vedi decisions.md).
 */
const LOGO_WIDTH = 979;
const LOGO_HEIGHT = 779;

export function Wordmark({ className, priority = false }: { className?: string; priority?: boolean }) {
  return (
    <Image
      src="/brand/logo.png"
      alt="Il Pozzo — Ristorante Enoteca"
      width={LOGO_WIDTH}
      height={LOGO_HEIGHT}
      sizes="170px"
      className={cn("h-12 w-auto shrink-0 sm:h-14 lg:h-[68px]", className)}
      priority={priority}
    />
  );
}
